import React from "react";

const AboutUs = () => {
  return <div>This is about</div>;
};

export default AboutUs;
